import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStatus from './status.reducer';

export const selectState = createFeatureSelector<fromStatus.State>(
  fromStatus.statusFeatureKey
);

export const getStatus = createSelector(selectState, (state) => state.status);
